import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  // Only used for drop-in UI
  async generateClientToken() {
    try {
      const response = await axios.get('braintree/token');
      return response.data;
    } catch (err) {
      return null;
    }
  },

  // Returns 0 if they have already paid or if the course is free
  async getClassPurchaseData(_, { classId, couponCode }) {
    let route = `braintree/price/${classId}`;
    if (couponCode) {
      route = `${route}?couponCode=${encodeURIComponent(couponCode)}`;
    }

    const response = await axios.get(route);
    return response.data;
  },

  purchaseCourse(_, { classId, paymentNonce, couponCode }) {
    return axios.post(`braintree/class/${classId}`, { paymentNonce, couponCode });
  },

  // ---- Content catalog (registration link) ----

  // Get the price of the requested catalog items (or the whole catalog if no
  // itemIds are provided), plus the resolved coupon and whether these items
  // have already been paid for. Returns { coupon, hasPaid, price }.
  async getCatalogPrice(_, { registrationLinkId, itemIds, couponCode }) {
    const params = {};
    if (itemIds && itemIds.length) params.itemIds = itemIds.join(',');
    if (couponCode) params.couponCode = couponCode;
    const response = await axios
      .get(`braintree/price/catalog/${encodeURIComponent(registrationLinkId)}`, { params });
    return response.data;
  },

  // Charge one or more catalog items. Resolves with the purchase result
  // object ({ success, transactionId, expirationDate }) or rejects on failure.
  async chargeCatalog(_, { registrationLinkId, itemIds, couponCode, paymentNonce }) {
    const body = { itemIds };
    if (couponCode) body.couponCode = couponCode;
    if (paymentNonce) body.paymentNonce = paymentNonce;
    const response = await axios
      .post(`braintree/catalog/${encodeURIComponent(registrationLinkId)}`, body);
    return response.data;
  },

  // Whether the user has already purchased the catalog for a given link.
  // Returns a boolean (never rejects; a failed lookup is treated as "not
  // purchased" so the user can still be offered the catalog).
  async hasPurchasedCatalog(_, { registrationLinkId }) {
    try {
      const response = await axios
        .get(`braintree/purchased/catalog/${encodeURIComponent(registrationLinkId)}`);
      return !!(response.data && response.data.purchased);
    } catch (err) {
      return false;
    }
  }
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/braintree/braintree.js